import { Grid } from "@material-ui/core";
import Box from "@mui/material/Box";
import { styleFind as style } from "../css/styleSheet";
import { Dispatch, SetStateAction } from "react";
import { removeAccents } from "../../../helpers/RemoveAccents";

interface Props<T> {
  initState: Array<T>;
  setState: Dispatch<SetStateAction<T[]>> | ((a: T[]) => void);
  stateInitial: Array<T>;
  label?: string;
  fields?: Array<string>;
  width?: number;
}

const SearcherCard = <T extends Object>({
  initState,
  setState,
  stateInitial,
  label = "Buscar",
  width = 420,
}: Props<T>) => {
  console.log(initState);
  console.log("estado inicial", stateInitial);
  const handleChange = (e: any) => {
    const array = [...stateInitial];
    if (e !== "") {
      const nuevoFiltrado = array.filter((lis: any) =>
        removeAccents(lis.nameTrainingPlan.toUpperCase()).includes(
          removeAccents(e.toUpperCase())
        )
      );
      console.log(nuevoFiltrado);
      if (nuevoFiltrado.length > 0) {
        console.log("si hay datos");
        setState(nuevoFiltrado);
      } else {
        console.log("No hay datos");
        setState(nuevoFiltrado);
      }
      // setState(nuevoFiltrado)
      // setStepFilter(nuevoFiltrado);
    } else {
      setState(stateInitial);
    }
  };

  return (
    <Grid item>
      <Box>
        <Grid
          container
          direction="row"
          style={{ ...style.containerSearcher, width: width }}
        >
          <Grid item>
            <input
              style={{ ...style.inputSearcher, width: width - 100 }}
              className="collaboratorTab__searcher"
              placeholder={label}
              onChange={(e) => handleChange(e.target.value)}
            />
          </Grid>

          <Grid
            item
            style={{
              width: "20px",
              padding: "0 20px 0 40px",
              color: "#7f7f81",
              fontStyle: "bold",
            }}
          >
            <img
              src="/assets/icons/icono-buscar.svg"
              alt="Buscar plan de capacitación"
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default SearcherCard;
